import { useEffect } from "react";

import { useUser } from "MVVM/Hooks/useUser";
import { useResolvedPaymentProvider } from "MVVM/Hooks/useResolvedPaymentProvider";
import { useUnlimitedOnlyPaywallLive } from "MVVM/Hooks/useUnlimitedOnlyPaywall";
import { TIER_DATA } from "MVVM/Views/Pricing/Components/PricingCards/features";

// Narrower than UpgradeCard's and StorageAddonModal's rule, which would pitch a
// trial at Standard subscribers who already pay. Unset userGroup means free.
const TRIAL_ELIGIBLE_TIERS = ["FREE", "ESSENTIALS"];
const TRIAL_TIER = "CREATOR_PLAT";

/**
 * Drives the bar-level "Start a free trial" button. Same paystation payload the
 * dropdown's TrialCard sends, so both routes land in the identical Stripe flow.
 */
export const useTrialCta = () => {
  const { allstarUser } = useUser();
  const { provider, resolve: resolveProvider } = useResolvedPaymentProvider();
  // Unlimited-only treatment buys outright (ALL-1929); this CTA bypassed the
  // useTrialEligibility gate and kept starting trials for the treatment arm.
  // Live (non-latched) read: the nav mounts before assignment settles, and the
  // latched value stays control for the whole page load (ALL-1932 leak).
  const { unlimitedOnly } = useUnlimitedOnlyPaywallLive();

  useEffect(() => {
    resolveProvider();
  }, [resolveProvider]);

  const userGroup = allstarUser?.user?.userGroup;
  // The trial flow is Stripe-only.
  const isXsollaUser =
    allstarUser?.user?.credits?.providerName === "XSOLLA" ||
    provider === "xsolla";
  const tierData = TIER_DATA.find((tier) => tier.key === TRIAL_TIER);

  const eligible = Boolean(
    allstarUser?.loggedIn &&
      !unlimitedOnly &&
      !isXsollaUser &&
      !userGroup?.hasUsedPlatinumTrial &&
      TRIAL_ELIGIBLE_TIERS.includes(userGroup?.type || "FREE") &&
      tierData,
  );

  // Deliberately tier-agnostic: the paystation modal does the selling, so the
  // button does not have to carry the tier name.
  return { eligible, label: "Start your free trial" };
};
